export const PLACEMENTS = [6, 12, 17, 24];



// WEBPACK FOOTER //
// ./src/constants/ads.js